import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'app/modules/shared/shared.module';
import { DataExportComponent } from './data-export.component';




@NgModule({
  declarations: [DataExportComponent],
  imports: [
    MatIconModule,
    SharedModule
  ],
  exports: [DataExportComponent]
})
export class DataExportModule { }
